import { onBeforeUnmount, onMounted } from 'vue'
import Mousetrap from 'mousetrap'

import { useReportGraphsDrawer } from '@app/application/report/store/use-report-graphs-drawer'
import {
  getLeftDrawerHotkey,
  isInputFocused,
} from '@app/application/behaviors/drawers/hotkeys'

// Binds ⌥/Alt + the left-drawer key to toggle the chart pane for the calling
// component's lifetime, mirroring the existing drawer hotkeys. Alt is the one
// modifier free of browser chrome collisions for these punctuation keys
// (mod+, is Preferences on macOS, mod+[ is Back) and Mousetrap matches alt
// combos by key code, so the locale variants also work on AZERTY layouts.
export function useReportPaneToggleHotkey(): void {
  const store = useReportGraphsDrawer()
  const hotkey = `alt+${getLeftDrawerHotkey()}`

  // Stays bound while the sidebar is closed so the shortcut can reopen it. The
  // `v-if` sits on the component's root element, so the component stays mounted.
  onMounted(() => {
    Mousetrap.bind(hotkey, () => {
      if (isInputFocused()) return true
      store.toggleDrawer()
      return false
    })
  })

  onBeforeUnmount(() => Mousetrap.unbind(hotkey))
}
